/**
 * Column Width Categories
 *
 * Standardized width definitions for table columns.
 * Each category defines minSize and maxSize in pixels.
 *
 * | Category | minSize | maxSize | Usage |
 * |----------|---------|---------|-------|
 * | XS       | 40      | 56      | Checkboxes, icons |
 * | S        | 72      | 96      | Status, short codes, numbers |
 * | M        | 120     | 160     | Dates, dropdown values |
 * | L        | 200     | 240     | Names, titles |
 * | XL       | 280     | 360     | Descriptions (rare) |
 * | Flexible | 160     | -       | Primary identifier column |
 */

import type { ColumnWidthCategory } from '../../components/types';

/** XS: Checkboxes, icons */
export const XS: ColumnWidthCategory = { minSize: 40, maxSize: 56 };

/** S: Status, short codes, numbers */
export const S: ColumnWidthCategory = { minSize: 72, maxSize: 96 };

/** M: Dates, dropdown values */
export const M: ColumnWidthCategory = { minSize: 120, maxSize: 160 };

/** L: Names, titles */
export const L: ColumnWidthCategory = { minSize: 200, maxSize: 240 };

/** XL: Descriptions (rare) */
export const XL: ColumnWidthCategory = { minSize: 280, maxSize: 360 };

/** Flexible: Primary identifier column (no maxSize) */
export const Flexible: ColumnWidthCategory = { minSize: 160 };
